/* ==========================================================================
   ILAVIYA — theme behaviour
   Vanilla, dependency-free, progressive enhancement.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---- Toast ------------------------------------------------------------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ilr-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-in'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-in'); }, 2200);
  }

  /* ---- Scroll lock ------------------------------------------------------- */
  var lockCount = 0;
  function lock() { lockCount++; document.documentElement.classList.add('ilr-noscroll'); }
  function unlock() {
    lockCount = Math.max(0, lockCount - 1);
    if (!lockCount) document.documentElement.classList.remove('ilr-noscroll');
  }

  /* ---- Sticky header ----------------------------------------------------- */
  function stickyHeader() {
    var header = $('[data-ilr-header]');
    if (!header) return;

    // Publish the header's real height so sticky elements below it (the
    // collection filter bar) can offset correctly. Hardcoding it drifted
    // whenever the logo lockup or nav changed size.
    var publish = function () {
      document.documentElement.style.setProperty('--ilr-stuck-h', header.offsetHeight + 'px');
    };

    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 20);
      publish();
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', publish);
    // the bar animates its height, so re-measure once the transition settles
    header.addEventListener('transitionend', publish);
    if ('ResizeObserver' in window) new ResizeObserver(publish).observe(header);
  }

  /* ---- Announcement auto-slide ------------------------------------------- */
  function autoSlideAnnouncement() {
    var announce = $('.ilr-announce__inner');
    if (!announce) return;
    setInterval(function() {
      if (window.innerWidth <= 989) {
        if (announce.scrollLeft + announce.clientWidth >= announce.scrollWidth - 10) {
          announce.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          announce.scrollBy({ left: announce.clientWidth, behavior: 'smooth' });
        }
      }
    }, 3000);
  }

  /* ---- Panels (search drawer + mobile drawer) ---------------------------- */
  function panel(rootSel, openSel, closeSel, focusSel) {
    var root = $(rootSel);
    if (!root) return;
    var open = function () {
      root.classList.add('is-open');
      lock();
      var header = $('[data-ilr-header]');
      if (header) header.classList.add('is-open');
      if (focusSel) {
        var f = $(focusSel, root) || $(focusSel);
        if (f) setTimeout(function () { f.focus(); }, 260);
      }
    };
    var close = function () {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      unlock();
      var header = $('[data-ilr-header]');
      if (header && !$('.ilr-search.is-open') && !$('.ilr-drawer.is-open')) header.classList.remove('is-open');
    };
    $$(openSel).forEach(function (b) { b.addEventListener('click', open); });
    $$(closeSel).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return { open: open, close: close };
  }

  /* ---- Mobile drawer submenus ------------------------------------------- */
  function drawerSubmenus() {
    $$('[data-ilr-submenu]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        var sub = btn.nextElementSibling;
        if (sub) sub.classList.toggle('is-open', !open);
      });
    });
  }

  /* ---- Header Nav Dropdowns (Mobile & Desktop Tap support) ---------------- */
  function navDropdowns() {
    var navItems = $$('.ilr-nav__item');
    if (!navItems.length) return;

    navItems.forEach(function(item) {
      var link = item.querySelector('.ilr-nav__link[aria-haspopup="true"]');
      var drop = item.querySelector('.ilr-dropdown') || item.querySelector('.ilr-mega');
      if (!link || !drop) return;

      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 1089) {
          e.preventDefault();
          var isOpen = item.classList.contains('is-active-drop');
          navItems.forEach(function(other) {
            if (other !== item) other.classList.remove('is-active-drop');
          });
          item.classList.toggle('is-active-drop', !isOpen);
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.ilr-nav__item')) {
        navItems.forEach(function(item) {
          item.classList.remove('is-active-drop');
        });
      }
    });
  }

  /* ---- Wishlist ---------------------------------------------------------- */
  var WKEY = 'ilaviya:wishlist';
  function wRead() {
    try {
      var raw = JSON.parse(localStorage.getItem(WKEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw.map(function (e) { return typeof e === 'string' ? { id: e, handle: '' } : e; });
    } catch (e) { return []; }
  }
  function wWrite(list, deferPageUI) {
    try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) {}
    wPaint(list.length, deferPageUI);
  }
  function wPaint(n, deferPageUI) {
    $$('[data-ilr-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    $$('[data-ilr-wishlist-header-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = false;
    });
    if (!deferPageUI) {
      $$('[data-ilr-wishlist-actions]').forEach(function (el) {
        el.hidden = n === 0;
      });
      if (n === 0) {
        $$('[data-ilr-wishlist-page]').forEach(function (sec) {
          var track = sec.querySelector('[data-ilr-rail-track]');
          var empty = sec.querySelector('[data-ilr-wishlist-empty]');
          var loader = sec.querySelector('[data-ilr-wishlist-loader]');
          if (loader) loader.hidden = true;
          if (empty) empty.hidden = false;
          if (track) track.innerHTML = '';
        });
      }
    }
  }
  function wIndex(list, id) {
    for (var i = 0; i < list.length; i++) if (list[i] && String(list[i].id) === String(id)) return i;
    return -1;
  }
  var wBound = false;
  function wishlist() {
    var list = wRead();
    wPaint(list.length);
    $$('[data-ilr-wish]').forEach(function (b) {
      if (wIndex(list, b.getAttribute('data-product-id')) !== -1) b.setAttribute('aria-pressed', 'true');
    });
    if (wBound) return;
    wBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ilr-wish]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-product-id');
      var handle = btn.getAttribute('data-product-handle') || '';
      var cur = wRead();
      var i = wIndex(cur, id);
      if (i === -1) {
        cur.push({ id: id, handle: handle });
        btn.setAttribute('aria-pressed', 'true');
        toast('Saved to wishlist');
        wWrite(cur);
      } else {
        cur.splice(i, 1);
        btn.setAttribute('aria-pressed', 'false');
        toast('Removed from wishlist');

        var wishPageCard = btn.closest('[data-ilr-wishlist-page] .ilr-card');
        if (wishPageCard) {
          var li = wishPageCard.closest('li') || wishPageCard.parentElement;
          if (li) {
            li.classList.add('is-removing');
            wWrite(cur, true);
            setTimeout(function () {
              li.remove();
              wPaint(cur.length, false);
            }, 350);
          } else {
            wWrite(cur);
          }
        } else {
          wWrite(cur);
        }
      }
      // keep every instance of this product in sync across the page
      $$('[data-ilr-wish][data-product-id="' + id + '"]').forEach(function (o) {
        o.setAttribute('aria-pressed', i === -1 ? 'true' : 'false');
      });
    });
  }

  /* ---- Cart: AJAX add ---------------------------------------------------- */
  function updateCartCount(count) {
    $$('[data-ilr-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  function fetchCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); })
      .catch(function () {});
  }
  function ajaxAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-ilr-add-form]');
      if (!form) return;

      // Mandatory size check for Quick Add / Quick View forms
      var sizeInputs = Array.prototype.slice.call(form.querySelectorAll('[data-is-size="true"]'));
      if (sizeInputs.length > 0) {
        var sizeSelected = sizeInputs.some(function(i) { return i.checked; });
        if (!sizeSelected) {
          e.preventDefault();
          var sizeOpt = form.querySelector('[data-option-is-size="true"]') || form.querySelector('.ilr-opt');
          if (sizeOpt) {
            sizeOpt.classList.remove('has-error');
            void sizeOpt.offsetWidth;
            sizeOpt.classList.add('has-error');
          }
          toast('Please select a size');
          return;
        }
      }

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);

      var editKey = form.getAttribute('data-ilr-edit-key');
      var oldVariant = form.getAttribute('data-ilr-edit-old-variant');
      var newVariant = formData.get('id');
      var newQty = formData.get('quantity') || 1;

      var finishUp = function(res, msg) {
        toast(msg);
        if (res && res.sections) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.renderContents(res);
        }
        fetchCartCount();
        var modal = document.getElementById('ilr-quick-modal');
        if (modal && modal.classList.contains('is-open')) {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      };
      
      var handleError = function(err) {
        toast(err.message || 'Something went wrong');
        if (btn) { btn.disabled = false; btn.innerHTML = original; }
      };

      if (editKey) {
        if (btn) btn.innerHTML = 'Updating…';
        if (String(oldVariant) === String(newVariant)) {
          // Only quantity changed
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: editKey, quantity: newQty, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
          })
          .then(function(r) { return r.json(); })
          .then(function(res) { finishUp(res, 'Cart updated'); })
          .catch(handleError);
        } else {
          // Variant changed: add new, then remove old
          fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
          .then(function(r) { return r.json().then(function(d) { return {ok: r.ok, d: d}; }); })
          .then(function(res) {
            if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not update cart');
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: editKey, quantity: 0, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
            });
          })
          .then(function(r) { return r.json(); })
          .then(function(res) { finishUp(res, 'Cart updated'); })
          .catch(handleError);
        }
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Could not add to cart');
          finishUp(res.d, 'Added to bag');
        })
        .catch(handleError);
    });
  }

  /* ---- Quick View Modal -------------------------------------------------- */
  function quickView() {
    var modal = document.getElementById('ilr-quick-modal');
    if (!modal) return;
    var body = document.getElementById('ilr-quick-modal-body');

    // Close logic
    $$('[data-ilr-quick-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    // Open logic
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ilr-quick-view-trigger]');
      if (!trigger) return;
      e.preventDefault();
      
      var handle = trigger.getAttribute('data-ilr-quick-view-trigger');
      var editVariant = trigger.getAttribute('data-ilr-edit-variant');
      var editQty = trigger.getAttribute('data-ilr-edit-qty');
      var editItemKey = trigger.getAttribute('data-ilr-edit-cart-item');

      var originalText = trigger.innerHTML;
      trigger.innerHTML = 'LOADING…';
      trigger.disabled = true;

      var fetchUrl = '/products/' + handle + '?section_id=ilaviya-quick-view';
      if (editVariant) fetchUrl += '&variant=' + editVariant;

      fetch(fetchUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var content = doc.querySelector('.shopify-section')?.innerHTML || html;
          body.innerHTML = content;
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          
          // Setup Variants inside Modal
          var varData = body.querySelector('[data-ilr-variants]');
          var variants = varData ? JSON.parse(varData.innerHTML) : [];
          var form = body.querySelector('form');
          var idInput = form ? form.querySelector('[name="id"]') : null;
          var atcBtn = form ? form.querySelector('[data-ilr-atc]') : null;
          var priceEl = body.querySelector('[data-ilr-price] .ilr-price');
          var imgEl = body.querySelector('.ilr-quick-view__media img');
          var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
          
          if (editItemKey && form) {
            form.setAttribute('data-ilr-edit-key', editItemKey);
            form.setAttribute('data-ilr-edit-old-variant', editVariant);
            if (qtyInput && editQty) qtyInput.value = editQty;
            if (atcBtn) atcBtn.innerHTML = 'Update Item';
          }
          
          if (variants.length > 0 && form) {
            body.addEventListener('change', function(e) {
              if (e.target.hasAttribute('data-ilr-opt-input')) {
                var sizeOpt = form.querySelector('[data-option-is-size="true"]');
                if (sizeOpt) sizeOpt.classList.remove('has-error');

                // Find selected options
                var checked = Array.prototype.slice.call(form.querySelectorAll('[data-ilr-opt-input]:checked'));
                var opts = [];
                checked.forEach(function(i) {
                  opts[parseInt(i.getAttribute('data-option-position'), 10)] = i.value;
                });
                
                // Find matching variant
                var match = null;
                for (var i = 0; i < variants.length; i++) {
                  var v = variants[i];
                  var ok = true;
                  for (var j = 0; j < opts.length; j++) {
                    if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; }
                  }
                  if (ok) { match = v; break; }
                }

                // Update label values
                checked.forEach(function(i) {
                  var pos = i.getAttribute('data-option-position');
                  var valSpan = form.querySelector('[data-ilr-opt-value="' + pos + '"]');
                  if (valSpan) valSpan.textContent = i.value;
                });
                
                // Update state
                if (match) {
                  idInput.value = match.id;
                  if (priceEl) {
                    var vPrice = (match.price / 100).toFixed(2).replace(/\.00$/, '');
                    priceEl.innerHTML = '₹' + vPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                  }
                  if (imgEl && match.featured_image && match.featured_image.src) {
                    imgEl.src = match.featured_image.src;
                  }
                  if (match.available) {
                    atcBtn.disabled = false;
                    if (atcBtn.querySelector('span')) atcBtn.querySelector('span').innerHTML = 'ADD TO BAG';
                  } else {
                    atcBtn.disabled = true;
                    if (atcBtn.querySelector('span')) atcBtn.querySelector('span').innerHTML = 'SOLD OUT';
                  }
                } else {
                  atcBtn.disabled = true;
                  if (atcBtn.querySelector('span')) atcBtn.querySelector('span').innerHTML = 'UNAVAILABLE';
                }
              }
            });
          }

          // Setup Quantity inside Modal
          body.addEventListener('click', function(e) {
            var qtyBtn = e.target.closest('[data-ilr-qty]');
            if (qtyBtn) {
              var step = parseInt(qtyBtn.getAttribute('data-ilr-qty'), 10);
              var input = body.querySelector('[data-ilr-qty-input]');
              if (input) {
                var v = parseInt(input.value, 10) || 1;
                input.value = Math.max(1, v + step);
              }
            }
          });
        })
        .catch(function (err) { toast('Error loading quick view'); })
        .finally(function() {
          trigger.innerHTML = originalText;
          trigger.disabled = false;
        });
    });
  }

  /* ---- Reveal on scroll -------------------------------------------------- */
  function reveal() {
    var els = $$('.ilr-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Modals (size guide etc.) ----------------------------------------- */
  function modals() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-ilr-modal-open]');
      if (opener) {
        var m = document.getElementById(opener.getAttribute('data-ilr-modal-open'));
        if (m) { m.hidden = false; lock(); var c = m.querySelector('[data-ilr-modal-close]'); if (c) c.focus(); }
        return;
      }
      var closer = e.target.closest('[data-ilr-modal-close]');
      if (closer) {
        var mm = closer.closest('[data-ilr-modal]');
        if (mm) { mm.hidden = true; unlock(); }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('[data-ilr-modal]:not([hidden])').forEach(function (m) { m.hidden = true; unlock(); });
    });
  }

  /* ---- Copy coupon ------------------------------------------------------- */
  function couponCopy() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ilr-copy]');
      if (!btn) return;
      var code = btn.getAttribute('data-ilr-copy');
      var done = function () {
        var was = btn.textContent;
        btn.textContent = 'Copied';
        btn.classList.add('is-copied');
        toast('Code ' + code + ' copied');
        setTimeout(function () { btn.textContent = was; btn.classList.remove('is-copied'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else { done(); }
    });
  }

  /* ---- Collection: filters + sort --------------------------------------- */
  // Builds the filtered URL from the drawer form, preserving the active sort.
  // Facet inputs appear twice — inline dropdowns for desktop and the drawer
  // for mobile — so collect from both and dedupe by name+value.
  function buildFilterUrl() {
    var base = window.location.pathname;
    var params = new URLSearchParams();
    var seen = {};

    $$('[data-ilr-facet]').forEach(function (input) {
      if (!input.name) return;
      var take = input.type === 'checkbox' ? input.checked : input.value !== '';
      if (!take) return;
      var key = input.name + '=' + input.value;
      if (seen[key]) return;
      seen[key] = true;
      params.append(input.name, input.value);
    });

    var sort = $('[data-ilr-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);

    var qs = params.toString();
    return qs ? base + '?' + qs : base;
  }

  function collection() {
    var sort = $('[data-ilr-sort]');
    if (sort) {
      sort.addEventListener('change', function () { window.location.href = buildFilterUrl(); });
    }
    $$('[data-ilr-filters-apply]').forEach(function (b) {
      b.addEventListener('click', function () { window.location.href = buildFilterUrl(); });
    });

    // Inline dropdowns apply immediately; the drawer waits for Apply on mobile
    $$('.ilr-fdrop [data-ilr-facet]').forEach(function (input) {
      if (input.type !== 'checkbox') return;
      input.addEventListener('change', function () { window.location.href = buildFilterUrl(); });
    });
    var form = $('[data-ilr-filter-form]');
    if (form && window.matchMedia('(min-width: 990px)').matches) {
      form.addEventListener('change', function (e) {
        if (e.target.type === 'checkbox') window.location.href = buildFilterUrl();
      });
    }

    // Grid density switch
    var grid = $('.ilr-grid');
    var sw = $('.ilr-viewswitch');
    if (grid && sw) {
      var apply = function (n) {
        grid.classList.toggle('ilr-grid--wide', n === '2');
        $$('button', sw).forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-ilr-view') === n));
        });
        try { localStorage.setItem('ilaviya:view', n); } catch (e) {}
      };
      sw.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-ilr-view]');
        if (b) apply(b.getAttribute('data-ilr-view'));
      });
      var saved;
      try { saved = localStorage.getItem('ilaviya:view'); } catch (e) {}
      if (saved) apply(saved);
    }

    // Only one inline dropdown open at a time
    document.addEventListener('click', function (e) {
      $$('.ilr-fdrop[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
  }

  /* ---- Product recommendations ------------------------------------------ */
  // Shopify only populates `recommendations.products` when the section is
  // requested through the recommendations route, so fetch and swap it in.
  function recommendations() {
    $$('[data-ilr-recommendations]').forEach(function (sec) {
      if (sec.dataset.ilrLoaded) return;
      var url = sec.getAttribute('data-url');
      if (!url) return;
      sec.dataset.ilrLoaded = '1';
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-ilr-rail-track]');
          var track = sec.querySelector('[data-ilr-rail-track]');
          if (fresh && track && fresh.children.length) {
            track.innerHTML = fresh.innerHTML;
            wishlist();
            reveal();
          } else {
            sec.hidden = true;
          }
        })
        .catch(function () { sec.hidden = true; });
    });
  }

  /* ---- Recently viewed --------------------------------------------------- */
  var RVKEY = 'ilaviya:recent';
  function trackRecent() {
    var el = $('[data-ilr-product]');
    if (!el) return;
    var handle = el.getAttribute('data-product-handle');
    if (!handle) return;
    var list;
    try { list = JSON.parse(localStorage.getItem(RVKEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RVKEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }

  function renderHandles(container, handles, sectionId, onEmpty, onSuccess) {
    if (!handles.length) { if (onEmpty) onEmpty(); return Promise.resolve(0); }
    return Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?section_id=' + sectionId)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })
    ).then(function (htmls) {
      var frag = document.createDocumentFragment();
      htmls.forEach(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var card = tmp.querySelector('.ilr-card');
        if (card) {
          var li = document.createElement('li');
          li.appendChild(card);
          frag.appendChild(li);
        }
      });
      var count = frag.childNodes.length;
      if (count) {
        container.innerHTML = '';
        container.appendChild(frag);
        wishlist();
        reveal();
        if (onSuccess) onSuccess();
      } else if (onEmpty) { onEmpty(); }
      return count;
    });
  }

  function recentlyViewed() {
    var sec = $('[data-ilr-recent]');
    if (!sec) return;
    var track = sec.querySelector('[data-ilr-rail-track]');
    if (!track) return;
    var currentHandle = sec.getAttribute('data-current-handle') || '';
    var list;
    try { list = JSON.parse(localStorage.getItem(RVKEY) || '[]'); } catch (e) { list = []; }
    list = list.filter(function (h) { return h && h !== currentHandle; }).slice(0, 8);
    renderHandles(track, list, 'ilaviya-card-fragment', function () { sec.hidden = true; });
  }

  /* ---- Wishlist page ----------------------------------------------------- */
  function wishlistPage() {
    var sec = $('[data-ilr-wishlist-page]');
    if (!sec) return;
    var track = sec.querySelector('[data-ilr-rail-track]');
    var empty = sec.querySelector('[data-ilr-wishlist-empty]');
    var loader = sec.querySelector('[data-ilr-wishlist-loader]');
    var clearBtn = $('[data-ilr-wishlist-clear]');
    if (!track) return;

    if (clearBtn && !clearBtn.dataset.ilrBound) {
      clearBtn.dataset.ilrBound = '1';
      clearBtn.addEventListener('click', function () {
        wWrite([]);
        toast('Wishlist cleared');
        $$('[data-ilr-wish]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
      });
    }

    var handles = wRead().map(function (e) { return e.handle; }).filter(Boolean);
    wPaint(handles.length, false);
    if (!handles.length) {
      if (loader) loader.hidden = true;
      return;
    }

    if (loader) loader.hidden = false;
    if (empty) empty.hidden = true;

    renderHandles(
      track,
      handles,
      'ilaviya-card-fragment',
      function () {
        if (loader) loader.hidden = true;
        if (empty) empty.hidden = false;
      },
      function () {
        if (loader) loader.hidden = true;
      }
    );
  }

  /* ---- Layout flags ------------------------------------------------------ */
  // The bottom nav is fixed, so the page needs bottom padding to clear it.
  // The CSS hook exists; nothing was setting it.
  function layoutFlags() {
    if ($('.ilr-bottomnav')) document.documentElement.classList.add('ilr-has-bottomnav');

    // The header is only marked transparent as a candidate. It may sit over a
    // hero without media, where white-on-light would make it invisible — so
    // confirm a hero with real media is actually there, else go solid.
    var header = $('[data-ilr-header]');
    if (header && header.classList.contains('ilr-header--transparent')) {
      var hero = $('[data-ilr-hero]');
      if (!hero || hero.getAttribute('data-has-media') !== 'true') {
        header.classList.remove('ilr-header--transparent');
      }
    }
  }

  /* ---- Card Swatches Hover Swap ----------------------------------------- */
  var swBound = false;
  function cardSwatches() {
    if (swBound) return;
    swBound = true;

    // Use event delegation for hover swaps so it works dynamically with AJAX
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest('.ilr-sw');
      if (!sw) return;

      var imgUrl = sw.getAttribute('data-variant-image');
      if (!imgUrl) return;

      var card = sw.closest('.ilr-card');
      if (!card) return;

      var img = card.querySelector('.ilr-card__img--main') || card.querySelector('.ilr-card__img');
      if (!img) return;

      // Save original src and srcset
      if (!img.getAttribute('data-orig-src')) {
        img.setAttribute('data-orig-src', img.getAttribute('src') || '');
        img.setAttribute('data-orig-srcset', img.getAttribute('srcset') || '');
      }

      // Swap to variant image and remove srcset
      img.setAttribute('src', imgUrl);
      img.removeAttribute('srcset');
      card.classList.add('ilr-card--swapping');
    }, { passive: true });

    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest('.ilr-sw');
      if (!sw) return;

      var card = sw.closest('.ilr-card');
      if (!card) return;

      var img = card.querySelector('.ilr-card__img--main') || card.querySelector('.ilr-card__img');
      if (!img) return;

      var origSrc = img.getAttribute('data-orig-src');
      var origSrcset = img.getAttribute('data-orig-srcset');

      if (origSrc !== null) {
        img.setAttribute('src', origSrc);
        if (origSrcset) {
          img.setAttribute('srcset', origSrcset);
        } else {
          img.removeAttribute('srcset');
        }
        img.removeAttribute('data-orig-src');
        img.removeAttribute('data-orig-srcset');
      }
      card.classList.remove('ilr-card--swapping');
    }, { passive: true });
  }

  /* ---- Init -------------------------------------------------------------- */
  function init() {
    layoutFlags();
    stickyHeader();
    autoSlideAnnouncement();
    panel('[data-ilr-filters]', '[data-ilr-filters-open]', '[data-ilr-filters-close]');
    collection();
    recommendations();
    trackRecent();
    recentlyViewed();
    wishlistPage();
    panel('[data-ilr-search]', '[data-ilr-search-open]', '[data-ilr-search-close]', '[data-ilr-search-input]');
    panel('[data-ilr-drawer]', '[data-ilr-drawer-open]', '[data-ilr-drawer-close]');
    drawerSubmenus();
    navDropdowns();
    wishlist();
    ajaxAdd();
    quickView();
    reveal();
    modals();
    couponCopy();
    cardSwatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', init);

  window.ILAVIYA = window.ILAVIYA = { toast: toast, updateCartCount: updateCartCount, refreshCart: fetchCartCount };
})();
